import { Carousel } from 'primereact/carousel';
import React, { useEffect } from 'react';
import InfoImg1 from '../../Assets/info_1.png';
import InfoImg2 from '../../Assets/info_2.png';
import InfoImg3 from '../../Assets/info_3.png';
import { FlexConteiner, Item, MainConteiner } from '../../Component/Conteiner/conteiner';
import Inform from '../../Component/Inform/inform';
import './information.scss';


const responsiveOptions = [
    {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
    },
    {
        breakpoint: '600px',
        numVisible: 2,
        numScroll: 2
    },
    {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1
    }
];

const itemsCarousel = [
    {
        image: InfoImg1,
        mainTitle1: <><div className="info-title-font-size"><mark className="info-mark-color">Quando devo fazer o teste de COVID-19?</mark></div></>, 
        title1: '',
        info1:
            <p className="info-font" >
                Se você apresentou algum dos sintomas ou
                esteve exposto ao coronavírus em locais onde
                houve transmissão, é indicado que você faça o
                teste. É importante considerar a quantos dias está
                com o sintoma ou houve a exposição para que seja
                escolhido o teste mais apropriado.<br/>
                O <strong>teste de anticorpos</strong> deve ser realizado a partir do
            </p>, 
        title2: '',
        info2:
            <p className="info-font"  align="justify">
                8º dia dos sintomas ou do contato.<br/>
                O <strong>teste de antígeno</strong> deve ser realizado até o 7º dia
                dos sintomas ou do contato.<br/><br/>
                <strong>Sintomas:</strong> febre, tosse, congestão nasal, espirros,
                cansaço excessivo, dor no corpo, dores de
                garganta, dificuldade em respirar.
            </p>
    },    
    {
        image: InfoImg2,
        title1: <><div className="info-title-font-size"><mark className="info-mark-color">Os testes são aprovados pela Anvisa?</mark></div></>,
        info1:
            <p className="info-font">
                A Anvisa aprovou a proposta de realização de
                testes rápidos de anticorpos e antígenos para
                o coronavírus em farmácias e drogarias.
                A medida visa ampliar a oferta e a rede de
                testagem, bem como reduzir a alta demanda
                em serviços públicos de saúde durante a
                pandemia.
            </p>, 
        title2: <><div className="info-title-font-size"><mark className="info-mark-color">Quais são os possíveis resultados dos testes realizados na farmácia?</mark></div></>,
        info2:
            <p className="info-font">
                O teste rápido deve ser interpretado por um
                médico, que vai considerar as condições clínicas do
                paciente, além de outros exames confirmatórios
                para concluir se o caso é ou não de COVID-19.
                Mesmo os resultados negativos não excluem a
                infecção pelo novo coronavírus.
            </p>
    },
    {
        image: InfoImg3,
        title1: <><div className="info-title-font-size"><mark className="info-mark-color">Todos os testes são confiáveis?</mark></div></>,
        info1:
            <p className="info-font">
                Sim, todos os testes são confiáveis. É
                importante que o teste seja realizado dentro
                dos dias indicados de sintomas ou do contato
                para cada tipo de teste pois os testes possuem
                uma taxa de precisão superior a 95%, quando
                dentro do período correto.
            </p>, 
        title2: <><div className="info-title-font-size"><mark className="info-mark-color">Existe alguma contraindicação para fazer os testes?</mark></div></>,
        info2:
            <p className="info-font">
                A idade minima permitida para realização do
                teste é de 2 anos. Sendo assim, o teste não é
                indicado para crianças com menos de 2 anos.
            </p>
    }
]


const Template = (item) => {
    return(       
        <> 
            <img className="info-image-test-type fadeIn" src={ item.image }/>
            <br/><br/>
            {item.mainTitle1 !== undefined && <FlexConteiner style={{textAlign:'center'}}>
                <Item>
                    {item.mainTitle1}                
                </Item>
            </FlexConteiner>}
            <FlexConteiner style={{textAlign:'left'}}>
                <Item>
                    {item.title1}
                    {item.info1}
                </Item>
                <Item>
                    {item.title2}
                    {item.info2}
                </Item>
            </FlexConteiner>
        </>
    ) 
}


const Information = ({show, onClick1, onClick2, onClick3, onClick4, onClick5}) => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    return (
        show ?
            <>
                <MainConteiner>
                    <Item className="info-item">
                        <Carousel
                            value={itemsCarousel} 
                            itemTemplate={Template} 
                            numVisible={1} 
                            numScroll={1} 
                            responsiveOptions={responsiveOptions}
                        />                        
                    </Item>
                    <Item className="info-item-width">
                        <Inform 
                            param4={ true }
                            onClick1={ onClick1 } 
                            onClick2={ onClick2 } 
                            onClick3={ onClick3 } 
                            onClick4={ onClick4 }
                            onClick5={ onClick5 }
                        />                        
                    </Item>                    
                </MainConteiner>                
            </>
        : <span/>
    )    
}

export default React.memo(Information)